__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "arbook-lti-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.13.9", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(2504))))));
			register("@flexreality/ui-toolkit", "0.1.65", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(4368))))));
			register("graphql", "16.11.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3942))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2635))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(961))))));
			register("react-i18next", "15.0.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(2389))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(2473))))));
			register("react", "18.3.1", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))));
			initExternal(237);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};